<div
  class="ddc-read-word-mobile-sheet"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <div class="sheet-content flex justify-center items-center">
    <div
      class="ddc-upgrade-card w-full max-w-md"
      [ngClass]="{
        ' text-gray-900': _isLightTheme,
        ' text-white': _isDarkTheme,
        'bg-[#f5e6d3] text-[#2c1810]': _isPaperTheme,
      }"
    >
      <div class="w-full flex flex-col items-center gap-2">
        <span
          class="text-lg font-semibold mb-2"
          [ngClass]="{
            'text-gray-900': _isLightTheme,
            'text-white': _isDarkTheme,
            'text-[#2c1810]': _isPaperTheme,
          }"
          >You are so close!</span
        >
        <ol class="list-decimal pl-5 text-base text-left w-full max-w-xs">
          <li
            [ngClass]="{
              'text-gray-800': _isLightTheme,
              'text-gray-200': _isDarkTheme,
              'text-[#2c1810]': _isPaperTheme,
            }"
          >
            Download <span class="font-bold">Daydic iOS App</span> from App Store and
            <span class="font-bold">Upgrade your Plan</span>
          </li>
          <li
            [ngClass]="{
              'text-gray-800': _isLightTheme,
              'text-gray-200': _isDarkTheme,
              'text-[#2c1810]': _isPaperTheme,
            }"
          >
            Play <span class="font-bold">Flashcards</span> & <span class="font-bold">Matching Games</span> on all
            dictionaries. Create personalized quizzes, figures and notes by <span class="font-bold">Lingo AI</span>!
          </li>
          <li
            [ngClass]="{
              'text-gray-800': _isLightTheme,
              'text-gray-200': _isDarkTheme,
              'text-[#2c1810]': _isPaperTheme,
            }"
          >
            Running <span class="font-bold">Canvases</span> needs an upgrade too! Create and run Canvases, with Lingo
            AI.
          </li>
        </ol>
      </div>
      <div class="flex flex-col items-center gap-3 mt-5">
        <button
          class="upgrade-page-btn"
          type="button"
          [ngClass]="{
            'bg-gray-900 text-white': _isLightTheme,
            'bg-white text-gray-900': _isDarkTheme,
            'bg-[#2c1810] text-[#f5e6d3]': _isPaperTheme,
          }"
          (click)="goToUpgrade()"
        >
          Upgrade your plan on our website
        </button>
        <span
          class="text-sm"
          [ngClass]="{
            'text-gray-600': _isLightTheme,
            'text-gray-300': _isDarkTheme,
            'text-[#2c1810]': _isPaperTheme,
          }"
          >or get it on iOS</span
        >
        <ddc-appstore-btn-small></ddc-appstore-btn-small>
      </div>
    </div>
  </div>
</div>
